import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function PhotoGallery() {
  const photoArticles = articles.filter((a) => a.category === 'photo').slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-primary-500 text-xs tracking-[0.2em] uppercase mb-2 font-label">Photo Gallery</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              写真集
            </h2>
          </div>
          <Link
            to="/category/photo"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {photoArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group relative rounded-lg overflow-hidden ${
                index === 0 ? 'col-span-2 row-span-2 h-96' : 'h-48'
              }`}
            >
              <img
                src={article.coverImage}
                alt={article.title}
                title={`友田真希 写真 ${article.title}`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-heading text-sm font-semibold line-clamp-1">
                  {article.title}
                </h3>
                <p className="text-white/70 text-xs mt-1">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}